'use client';
import { Checkbox, Label } from '@v2/ui';
import { useEffect, useState } from 'react';

interface CheckboxOption {
  id: string;
  value: string;
  label: string;
  rightText?: string;
}

interface CheckboxFilterGroupProps {
  title: string;
  options?: CheckboxOption[];
  onChange: (selectedOptions: string[]) => void;
  className?: string;
  multiSelect?: boolean;
  initialSelectedOptions?: string[];
}

export function CheckboxFilterGroup({
  title,
  options = [],
  onChange,
  className = '',
  multiSelect = true,
  initialSelectedOptions = [],
}: CheckboxFilterGroupProps) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    initialSelectedOptions
  );

  useEffect(() => {
    setSelectedOptions(initialSelectedOptions);
  }, [initialSelectedOptions]);

  const handleOptionChange = (optionId: string) => {
    let newSelectedOptions: string[];
    if (multiSelect) {
      newSelectedOptions = selectedOptions.includes(optionId)
        ? selectedOptions.filter((id) => id !== optionId)
        : [...selectedOptions, optionId];
    } else {
      newSelectedOptions = [optionId];
    }
    setSelectedOptions(newSelectedOptions);
    onChange(newSelectedOptions);
  };

  return (
    <div className={className}>
      <h4 className="mb-3 text-base font-bold text-gray-800">{title}</h4>
      <div className="space-y-3">
        {options.map((option) => (
          <div key={option.id} className="flex items-start justify-between gap-4">
            <div className="flex min-w-0 items-start gap-x-3">
              <Checkbox
                size="md"
                className="mt-0.5 bg-white"
                id={option.id}
                checked={selectedOptions.includes(option.value)}
                onCheckedChange={() => {
                  handleOptionChange(option.value);
                }}
              />
              <Label
                htmlFor={option.id}
                className="text-base font-medium leading-6 text-gray-800"
              >
                {option.label}
              </Label>
            </div>
            {option.rightText && (
              <span className="shrink-0 text-base font-medium leading-6 text-gray-800">
                {option.rightText}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
